"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleBookingStepCompleted = exports.findStepIndex = void 0;
var lodash_1 = require("lodash");
var booking_events_1 = require("./booking_events");
var page_meta_event_1 = require("./page_meta_event");
function findStepIndex(path) {
    for (var _i = 0, mapping_1 = page_meta_event_1.mapping; _i < mapping_1.length; _i++) {
        var pageCategory = mapping_1[_i];
        if (pageCategory.category === 'checkout') {
            for (var i = 0; i < pageCategory.pages.length; i++) {
                if (pageCategory.pages[i].regex.test(path)) {
                    return i;
                }
            }
        }
    }
    return -1;
}
exports.findStepIndex = findStepIndex;
var handleBookingStepCompleted = function (mutation, state, stepIndex) {
    if (stepIndex === void 0) { stepIndex = findStepIndex(mutation.payload.to.fullPath); }
    var cabinNames = (0, lodash_1.get)(state, 'booking.basket', []);
    var cabinProducts = (0, lodash_1.map)(cabinNames, function (cabinName) {
        var transports = stepIndex >= 3 ? (0, booking_events_1.getTransportationProducts)(state, cabinName) : [];
        var insurance = stepIndex >= 5 ? (0, booking_events_1.getInsuranceProducts)(state, cabinName) : [];
        return __spreadArray(__spreadArray([(0, booking_events_1.getCruiseProduct)(state, cabinName)], transports, true), insurance, true);
    });
    var products = (0, lodash_1.flatten)(cabinProducts);
    var agencyId = (0, lodash_1.get)(state, 'booking.affiliate.agencyId', '');
    return [
        {
            event: 'EECcheckout',
            ecommerce: {
                dimension67: agencyId,
                checkout: {
                    actionField: {
                        step: "".concat(stepIndex + 1),
                    },
                    products: products,
                },
            },
        },
    ];
};
exports.handleBookingStepCompleted = handleBookingStepCompleted;
//# sourceMappingURL=booking_step_events.js.map